export default __webpack_public_path__ + "static/media/SuperToDo1.ed6d614e.jpg";